import React from 'react';

const features = [
  {
    badge: '24H',
    title: 'Fast Delivery',
    description: 'Get fresh produce delivered quickly with a workflow built for repeat household orders.'
  },
  {
    badge: 'ORG',
    title: 'Quality Produce',
    description: 'Fresh products are selected with a cleaner quality-first process before dispatch.'
  },
  {
    badge: 'FARM',
    title: 'Direct from Farmers',
    description: 'A shorter sourcing chain helps preserve freshness while supporting growers fairly.'
  },
  {
    badge: 'SAVE',
    title: 'Best Prices',
    description: 'Sharper pricing and deal visibility make everyday shopping more predictable.'
  },
  {
    badge: 'SAFE',
    title: 'Secure Payment',
    description: 'Multiple payment options keep checkout simple for customers on mobile and desktop.'
  },
  {
    badge: 'PLUS',
    title: 'Loyalty Value',
    description: 'Returning shoppers benefit from stronger retention offers and repeat-purchase convenience.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="bg-gradient-to-b from-primary-50 to-white py-6 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6 text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.25em] text-[#F4B800]">Why Customers Stay</span>
          <h2 className="mt-3 text-3xl font-bold text-gray-900 sm:text-4xl">Why choose KKisan?</h2>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-[28px] border border-gray-100 bg-white p-8 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-xl"
            >
              <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 text-sm font-bold tracking-[0.2em] text-[#2E7B52]">
                {feature.badge}
              </div>
              <h3 className="mb-3 text-xl font-semibold text-gray-900">{feature.title}</h3>
              <p className="text-base text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
